// Components
import { requestPayoutApi } from './common';

export type SignInResponse = {
  userId: string;
  token: string;
  legacyToken: string;
  payoutToken: string;
  firstname: string | null;
  lastname: string | null;
  email: string | null;
  phoneNumber: string | null;
  isGuest: boolean;
};

export const signIn = ({ email, password }): Promise<SignInResponse> =>
  requestPayoutApi({
    api: '/api/users/sign-in',
    authorized: false,
    body: { email: email, password: password },
    method: 'POST'
  });
